"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8630],{

/***/ 68208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ReadMoreText; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/react-collapsed/dist/react-collapsed.esm.js + 1 modules
var react_collapsed_esm = __webpack_require__(65587);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/react-bootstrap/esm/Modal.js + 50 modules
var Modal = __webpack_require__(94549);
// EXTERNAL MODULE: ../../shared/node_modules/react-bootstrap/esm/CloseButton.js
var CloseButton = __webpack_require__(382);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./components/SimpleModal.tsx




var SimpleModal = function(param) {
    var modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, show = param.show, children = param.children, Title = param.Title, Content = param.Content, faIcon = param.faIcon, _updateUri = param.updateUri, updateUri = _updateUri === void 0 ? true : _updateUri;
    var ref = (0,react.useState)(show || false), showSimpleModal = ref[0], setShowSimpleModal = ref[1];
    var router = (0,next_router.useRouter)();
    var hasHash = router.asPath.includes("#");
    var openHandler = function() {
        if (updateUri) {
            if (!hasHash) {
                router.push({
                    hash: modalName + ""
                }, undefined, {
                    scroll: false
                });
            }
        }
        setShowSimpleModal(true);
    };
    var closeHandler = function() {
        closeModal();
        setShowSimpleModal(false);
        if (updateUri) {
            if (showSimpleModal) {
                router.back();
            }
        }
    };
    var clickOutSideHandler = function() {
        closeModal();
        setShowSimpleModal(false);
    };
    (0,react.useEffect)(function() {
        if (show) openHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        show
    ]);
    (0,react.useEffect)(function() {
        if (!hasHash && showSimpleModal) clickOutSideHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHash
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        className: className,
        size: modalSize,
        show: showSimpleModal,
        onHide: closeHandler,
        animation: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Header */.Z.Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        onClick: closeHandler
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "m-auto fa-2x " + faIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "m-auto",
                        children: Title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 p-t-20 no-margin text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: Content
                            }
                        })
                    })
                })
            }),
            children
        ]
    });
};
/* harmony default export */ var components_SimpleModal = (/*#__PURE__*/(0,react.memo)(SimpleModal));

// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/ReadMoreText.tsx








function ReadMoreText(props) {
    var overviewParagraphsLimit = props.hasOwnProperty("overviewParagraphsLimit") ? props.overviewParagraphsLimit : 1;
    var applyRegex = props.hasOwnProperty("applyRegex") ? props.applyRegex : true;
    var layout = 1;
    var ref = (0,react.useState)("close"), modalState = ref[0], setModalState = ref[1];
    var handleShow = function(state) {
        setModalState(state);
    };
    var handleHide = function() {
        setModalState("close");
    };
    var ref1 = (0,react.useState)(false), isExpanded = ref1[0], setExpanded = ref1[1];
    var getCollapseProps = (0,react_collapsed_esm/* default */.Z)({
        isExpanded: isExpanded
    }).getCollapseProps;
    var text = null;
    if (applyRegex) {
        text = Checkers/* default.isValidString */.Z.isValidString(props.text) ? props.text.match(/<(.)*>.*?<\/\1>/g) : null;
    } else {
        text = Checkers/* default.isValidString */.Z.isValidString(props.text) ? props.text : null;
    }
    var intro_text = "";
    if (props.text === null) {
        text = "";
    } else if (props.text != undefined && (!Checkers/* default.isValidArray */.Z.isValidArray(text) || text.length == 1)) {
        text = props.text.replace("<p></p>", "");
        text = text.split("</p>").filter(Boolean);
    }
    if (props.text === null) {
        text = "";
    } else if (!Checkers/* default.isValidArray */.Z.isValidArray(text) || text.length == 1) {
        layout = 2;
        intro_text = props.text != undefined ? props.text.slice(0, props.letters) : "";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: layout == 1 ? Checkers/* default.isValidArray */.Z.isValidArray(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: props.className,
                children: [
                    text.map(function(item, key) {
                        if (key < overviewParagraphsLimit) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: item
                                        }
                                    })
                                }, key.toString())
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getCollapseProps({})), {
                        children: text.map(function(item, key) {
                            if (key >= overviewParagraphsLimit) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: item
                                            }
                                        })
                                    }, key.toString())
                                });
                            }
                        })
                    })),
                    Checkers/* default.isValidArray */.Z.isValidArray(text) && text.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn-link text-link",
                            onClick: function() {
                                return setExpanded(function(value) {
                                    return !value;
                                });
                            },
                            children: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,MethodHelper/* btnTextColor */.Nd)(props.darkMode),
                                children: "Read less..."
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,MethodHelper/* btnTextColor */.Nd)(props.darkMode),
                                children: "Read more..."
                            })
                        })
                    })
                ]
            })
        }) : props.text != undefined && layout == 2 && props.text.length != intro_text.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: props.className,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: intro_text + "..."
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-link text-link",
                        onClick: function() {
                            return handleShow("distincts_read_more");
                        },
                        children: isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,MethodHelper/* btnTextColor */.Nd)(props.darkMode),
                            children: "Read less..."
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,MethodHelper/* btnTextColor */.Nd)(props.darkMode),
                            children: "Read more..."
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimpleModal, {
                    modalName: "distincts_read_more",
                    className: "center",
                    Title: props.title,
                    Content: props.text,
                    faIcon: props.faIcon,
                    modalSize: "lg",
                    closeModal: function() {
                        handleHide();
                    },
                    show: modalState === "distincts_read_more",
                    updateUri: false
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: props.className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    dangerouslySetInnerHTML: {
                        __html: intro_text
                    }
                })
            })
        })
    });
}


/***/ }),

/***/ 11912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FeaturedImages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34357);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(417);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41410);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92669);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69038);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83974);
/* harmony import */ var _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81746);
/* harmony import */ var _Motto__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90138);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31602);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);




// import Swiper core and required modules

// Import Swiper React components






// Import Swiper styles

// install Swiper modules
swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Lazy */ .oM
]);
function FeaturedImages(props) {
    var autoplay = {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    };
    var swiper_options = {
        mode: "white"
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (router.route.includes("/blog")) {
            if (window !== undefined) {
                swiper_options.mode = window.designMode == 1 ? "white" : "dark";
            }
            new _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z(swiper_options).swiperOptions();
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
            speed: 1000,
            navigation: true,
            pagination: true,
            slidesPerView: 1,
            autoplay: props.jumbotronAutoplay ? autoplay : false,
            children: props.album !== undefined ? props.album !== null && props.album.length > 0 ? props.album.map(function(slide, key) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            priority: key == 0,
                            // loading={key == 0 ? 'eager' : 'lazy'}
                            "data-fancybox": _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isValidString */ .Z.isValidString(props.dataFancybox) ? props.dataFancybox : "",
                            "data-src": _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].booleanState */ .Z.booleanState(props.fancybox) && slide.image,
                            "data-thumb": _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_8__/* ["default"].booleanState */ .Z.booleanState(props.fancybox) && slide.image,
                            layout: "fill",
                            sizes: "75vw",
                            quality: "75",
                            src: slide.image,
                            alt: "Slide-" + key,
                            placeholder: "blur",
                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        }),
                        key === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Motto__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            isDesktop: props.isDesktop,
                            motto: props.motto,
                            logoDecoration: props.logoDecoration,
                            logoDecorationOriginWidth: props.logoDecorationOriginWidth,
                            logoDecorationOriginHeight: props.logoDecorationOriginHeight,
                            jumbotronTextAlign: props.jumbotronTextAlign,
                            jumbotronTextColor: props.jumbotronTextColor,
                            sliderTitleShadow: props.sliderTitleShadow,
                            sliderTitleBold: props.sliderTitleBold,
                            homeTitle: props.homeTitle,
                            homeSubtitle: props.homeSubtitle
                        }),
                        props.jumbotronOverlayOpacity > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "bg-overlay z-index-1",
                            style: {
                                backgroundColor: "rgb(0, 0, 0)",
                                opacity: props.jumbotronOverlayOpacity
                            }
                        })
                    ]
                }, key);
            }) : "" : ""
        })
    });
}


/***/ }),

/***/ 18630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleCategoriesContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91932);
/* harmony import */ var _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(76191);
/* harmony import */ var _fortawesome_pro_thin_svg_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23267);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96350);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62290);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _Jumbotron__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69350);
/* harmony import */ var _jumbotron_FeaturedImages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11912);
/* harmony import */ var _ReadMoreText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68208);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39806);
/* harmony import */ var _ArticleTypes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54106);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31969);
/* harmony import */ var _properties_partials_TabsContentWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3055);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37226);
/* harmony import */ var _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87091);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72976);
/* harmony import */ var _contact_ContactForm__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46532);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);




















function ArticleCategoriesContainer(props) {
    var showFullContent = props.content.hasOwnProperty("showFullContent") ? props.content.showFullContent : false;
    var contentFullwidth = props.content.hasOwnProperty("contentFullwidth") ? props.content.contentFullwidth : false;
    var hideTitleInnerPage = props.content.hasOwnProperty("hideTitleInnerPage") ? props.content.hideTitleInnerPage : false;
    var titleClassName = props.titleClassName != undefined ? props.titleClassName : "";
    var subtitleInherited = props.subtitleInherited != undefined ? props.subtitleInherited : "";
    var paddingTop = props.paddingTopClassName != undefined ? props.paddingTopClassName : "p-t-100";
    var paddingBottomClassName = props.paddingBottomClassName != undefined ? props.paddingBottomClassName : "";
    var viewMoreBtnStyle = props.viewMoreBtnStyle != undefined ? props.viewMoreBtnStyle : "primary";
    var showAllLabel = props.hasOwnProperty("showAllLabel") ? props.showAllLabel : "Show all";
    var articleSectionContent = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.section_content) ? props.content.section_content : null;
    var articleSectionJumbotronContent = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.section_jumbotron) ? props.content.section_jumbotron : null;
    var articleSectionRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var app_data = props.app_data;
    var app = props.app;
    var builder = props.builder;
    var content_type = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.type) && props.type;
    var hideArticles = props.content.hide_articles;
    var subtitle = content_type == "category" ? props.content.description : props.content.subtitle;
    var viewType = props.inheritedViewType != undefined ? props.inheritedViewType : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_view_type") ? builder.builder_news_view_type : "172";
    if (props.inheritedViewType == undefined && (content_type == "category" || content_type == "experiences")) {
        viewType = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(props.content, "view_type") ? props.content.view_type : "172";
    }
    var containerClassname = function() {
        if (props.content.category_view_width == "container") {
            return props.content.category_view_width;
        }
        return props.content.category_view_width + " p-l-0 p-r-0";
    };
    var hideImage = function() {
        return props.content.hide_image;
    };
    var backgroundColor = function() {
        if (props.backgroundColor != undefined) {
            return props.backgroundColor;
        }
        if (content_type == "blog") {
            if (app.builder.builder_news_bg_color != null && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isHexColor */ .Z.isHexColor(app.builder.builder_news_bg_color)) {
                return app.builder.builder_news_bg_color;
            }
        } else {
            if (props.content.background_color != null && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isHexColor */ .Z.isHexColor(props.content.background_color)) {
                return props.content.background_color;
            }
        }
        return null;
    };
    var textColor = function() {
        if (props.textColor != undefined) {
            return props.textColor;
        }
        if (content_type == "blog") {
            if (app.builder.builder_news_dark_theme_color != 1) {
                return "text-light-color";
            }
            return "";
        } else {
            if (props.content.dark_text != undefined && props.content.dark_text == true) {
                return "text-light-color";
            }
            return "";
        }
    };
    var showTitle = function() {
        if (props.includeTitle != undefined && props.includeTitle === false) {
            return false;
        }
        return true;
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), reactComponentsArrayLoading = ref[0], setReactComponentsArrayLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), tabsArrayComponents = ref1[0], setTabsArrayComponents = ref1[1];
    var checkAvailableDaysForExperience = function() {
        return props.content.availableMonday || props.content.availableTuesday || props.content.availableWednesday || props.content.availableThursday || props.content.availableFriday || props.content.availableSaturday || props.content.availableSunday;
    };
    var hasDuration = function() {
        return props.content.bookingType == "191" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.duration);
    };
    var hasPaymentPeriod = function() {
        return props.content.bookingType == "193" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.paymentPeriodType);
    };
    var captchaSiteKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["captchaSiteKey"];
    });
    var getTabbedContent = function() {
        var result = [];
        var details = props.content.details;
        var expectations = props.content.expectations;
        var highlights = props.content.highlights;
        var availableDays = [
            {
                dayOfTheWeek: "Monday",
                available: props.content.availableMonday
            },
            {
                dayOfTheWeek: "Tuesday",
                available: props.content.availableTuesday
            },
            {
                dayOfTheWeek: "Wednesday",
                available: props.content.availableWednesday
            },
            {
                dayOfTheWeek: "Thursday",
                available: props.content.availableThursday
            },
            {
                dayOfTheWeek: "Friday",
                available: props.content.availableFriday
            },
            {
                dayOfTheWeek: "Saturday",
                available: props.content.availableSaturday
            },
            {
                dayOfTheWeek: "Sunday",
                available: props.content.availableSunday
            }
        ];
        var basePrice = props.content.basePrice;
        var duration = props.content.duration;
        var paymentPeriodTypeLabel = props.content.paymentPeriodTypeLabel;
        var enableInquire = props.content.enableInquire;
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(details)) {
            result.push({
                tabId: "important-info",
                tabTitle: "Important info",
                tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: details
                        }
                    })
                })
            });
        }
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(expectations) || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(highlights)) {
            result.push({
                tabId: "overview",
                tabTitle: "Overview",
                tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(highlights) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "m-b-30",
                                dangerouslySetInnerHTML: {
                                    __html: highlights
                                }
                            })
                        }),
                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(expectations) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: expectations
                                }
                            })
                        })
                    ]
                })
            });
        }
        if (checkAvailableDaysForExperience() || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(basePrice) || hasDuration() || hasPaymentPeriod()) {
            result.push({
                tabId: "details",
                tabTitle: "Details",
                tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        checkAvailableDaysForExperience() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "panel m-b-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-design-color h6 m-b-20",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faCalendar */ .fT7
                                            }),
                                            "\xa0Available days"
                                        ]
                                    }),
                                    availableDays.map(function(item) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    item.dayOfTheWeek,
                                                    "\xa0",
                                                    item.available ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                            icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_16__/* .faCheck */ .LEp,
                                                            className: "text-success"
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                            icon: _fortawesome_pro_regular_svg_icons__WEBPACK_IMPORTED_MODULE_16__/* .faXmark */ .g82,
                                                            className: "text-danger"
                                                        })
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                ]
                            })
                        }),
                        hasDuration() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "panel m-b-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-design-color h6 m-b-20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faClock */ .SZw
                                        }),
                                        "\xa0Duration\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-muted",
                                            children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidNumber */ .Z.isValidNumber(duration) ? duration + " hours" : duration
                                        })
                                    ]
                                })
                            })
                        }),
                        hasPaymentPeriod() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "panel m-b-20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-design-color h6 m-b-20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                            icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faCreditCard */ .Ozh
                                        }),
                                        "\xa0Payment type\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-muted",
                                            children: paymentPeriodTypeLabel
                                        })
                                    ]
                                })
                            })
                        }),
                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(basePrice) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-design-color h6 m-b-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faTag */ .LEN
                                    }),
                                    "\xa0Price\xa0",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "text-muted",
                                        children: [
                                            "€\xa0",
                                            basePrice
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
        if (enableInquire) {
            result.push({
                tabId: "inquiry",
                tabTitle: "Inquiry",
                tabContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contact_ContactForm__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        captchaSiteKey: captchaSiteKey,
                        showDestination: false,
                        showDates: false,
                        containerClass: "col-12",
                        experienceId: props.content.id,
                        experienceTitle: props.content.title,
                        insideSingleProperty: false
                    })
                })
            });
        }
        // result.push({
        //   tabId: "tab-4",
        //   tabTitle: 'tab 4',
        //   tabContent: <p>here is a tab 4</p>
        // })
        setTabsArrayComponents(result);
        setReactComponentsArrayLoading(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (reactComponentsArrayLoading) {
            getTabbedContent();
        }
    });
    var config = {
        disconnectOnLeave: false
    };
    var tabsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var options = {};
    var inViewport = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_12__/* .useInViewport */ .NM)(tabsRef, options, config).inViewport;
    // const articleSectionRefInViewPort =  useInViewport(
    //     articleSectionRef,
    //     options,
    //     config
    // )
    var getCategoryUrl = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.redirectUrl)) {
            return props.content.redirectUrl;
        }
        return "/" + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.urlSlug) ? props.content.urlSlug : props.content.loggiaUrl);
    };
    var categoryUrlIsBlank = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.redirectUrl)) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: hideArticles && props.categoryIdInhrerited != undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "p-b-100 " + paddingTop + " bg-master-darkest design_color lazyload-pages-bg-image",
                "data-pages-bg-image": props.content.images[0] != undefined ? props.content.images[0].image : "",
                "data-pages-bg-webp": props.content.images[0] != undefined ? props.content.images[0].image : "",
                "data-pages": "parallax",
                // data-bg-overlay="black" data-overlay-opacity="0.25"
                style: {
                    minHeight: "300px",
                    backgroundImage: "url(" + (props.content.images[0] != null ? props.content.images[0].image : "") + ")",
                    backgroundPosition: "center 39.9972%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "background-overlay",
                        style: {
                            backgroundColor: "rgba(0, 0, 0)",
                            opacity: 0.4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container text-center sm-p-t-20",
                        style: {
                            zIndex: 9
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                className: "block-title text-white m-b-0",
                                children: props.content.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-white m-b-0 m-t-5",
                                children: props.content.description
                            }),
                            props.content.hasBody || props.content.articlesCount > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: categoryUrlIsBlank() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        href: getCategoryUrl(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "p-3 p-l-20 p-r-20 btn btn-white m-t-20",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "d-flex flex-wrap",
                                                children: [
                                                    "Read about ",
                                                    props.content.description
                                                ]
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                                        href: getCategoryUrl(),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "p-3 p-l-20 p-r-20 btn btn-white m-t-20",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "d-flex flex-wrap",
                                                children: [
                                                    "Read about ",
                                                    props.content.description
                                                ]
                                            })
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: props.content.urlSlug,
                style: {
                    background: backgroundColor()
                },
                className: paddingBottomClassName,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        props.includeJumbotron && !hideImage() && (content_type == "category" || content_type == "experiences") && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(props.content.images) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Jumbotron__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            jumbotronClass: "",
                            album: props.content.images,
                            sliderSearchBar: false,
                            isDesktop: props.isDesktop,
                            jumbotronTextColor: app.jumbotronTextColor,
                            jumbotronHeight: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidNumber */ .Z.isValidNumber(builder.builder_article_category_jumbotron_height) ? builder.builder_article_category_jumbotron_height : 75
                        }),
                        showTitle() && !props.hideTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            parentClassName: "container mt-5 mb-5",
                            skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        height: 43,
                                        className: "col-8 col-sm-6 col-md-4 b-rad-md mb-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        height: 55,
                                        className: "col-12 col-sm-12 col-md-8 b-rad-md mb-2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        height: 45,
                                        className: "col-10 col-sm-8 col-md-6 b-rad-md mb-1"
                                    })
                                ]
                            }),
                            children: // !props.hideTitle ?
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " pb-4 " + (props.categoryIdInhrerited != undefined ? paddingTop : "pt-5"),
                                    style: {
                                        background: backgroundColor()
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: containerClassname() + (contentFullwidth ? " container-fluid " : " container ") + "bg-master-lightest",
                                        style: {
                                            background: backgroundColor()
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row justify-content-center w-100 m-0 " + titleClassName,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (contentFullwidth ? "p-0" : "") + " col-12 col-sm-12 text-center d-flex flex-column " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(titleClassName) ? titleClassName : "align-items-center"),
                                                children: content_type == "blog_article" || content_type == "article" || content_type == "excursion" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        content_type == "blog_article" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "block-title mb-0",
                                                            children: moment__WEBPACK_IMPORTED_MODULE_3___default()(props.content.created * 1000).format("dddd Do MMMM")
                                                        }),
                                                        hideTitleInnerPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: props.categoryIdInhrerited != undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                        className: textColor() + " mt-1 fw-normal hidden-xs hidden-sm hidden-md m-b-0",
                                                                        children: props.content.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                        className: textColor() + "mt-1 fw-normal visible-xs visible-sm visible-md m-b-0",
                                                                        children: props.content.title
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                        className: textColor() + " mt-1 fw-normal hidden-xs hidden-sm hidden-md",
                                                                        children: props.content.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                        className: textColor() + "mt-1 fw-normal visible-xs visible-sm visible-md",
                                                                        children: props.content.title
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: textColor(),
                                                            children: props.content.subtitle
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        hideTitleInnerPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                props.categoryIdInhrerited != undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(subtitleInherited) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            className: "block-title m-t-40 hint-text no-margin " + titleClassName,
                                                                            children: subtitleInherited
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                            className: textColor() + " mt-1 fw-normal m-b-0 " + titleClassName,
                                                                            children: props.content.title
                                                                        }),
                                                                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(subtitle) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                            className: textColor() + " block-title mb-0 m-t-0 " + titleClassName,
                                                                            children: subtitle
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                            className: textColor() + " mt-1 fw-normal",
                                                                            children: props.content.title
                                                                        }),
                                                                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(subtitle) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: textColor() + " block-title mb-0 fs-20",
                                                                            children: subtitle
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                                    ]
                                                                }),
                                                                props.categoryIdInhrerited != undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                                            className: textColor() + " text-master opacity-50 py-4 hidden-xs hidden-sm hidden-md",
                                                                            icon: _fortawesome_pro_thin_svg_icons__WEBPACK_IMPORTED_MODULE_18__/* .faArrowDown */ .r5q,
                                                                            size: "2x"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                                                            className: textColor() + " text-master opacity-50 py-3 fs-16 visible-xs visible-sm visible-md",
                                                                            icon: _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_19__/* .faArrowDown */ .r5q
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        showFullContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: textColor() + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_general_description_centered) ? "text-md-center" : "text-md-justify"),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: props.content.body
                                                                    }
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: (content_type == "category" || content_type == "experiences") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReadMoreText__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                                                className: textColor() + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_general_description_centered) ? "text-md-center" : "text-md-justify"),
                                                                lines: 4,
                                                                text: props.content.body,
                                                                isDesktop: props.isDesktop
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(props.content.images) && (content_type == "blog_article" || content_type == "article" || content_type == "excursion") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            parentClassName: "container mb-5",
                            skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row text-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    height: 500,
                                    className: "col-12 col-sm-12 col-md-10 b-rad-md mb-1"
                                })
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Jumbotron__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                jumbotronClass: "mb-5",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container h-100",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row justify-content-center h-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-12 col-sm-12 col-md-12",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_jumbotron_FeaturedImages__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                                fancybox: true,
                                                dataFancybox: "blog-images",
                                                isDesktop: props.isDesktop,
                                                album: props.content.images,
                                                designMode: app.designMode
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: articleSectionRef,
                            dangerouslySetInnerHTML: {
                                __html: articleSectionJumbotronContent
                            }
                        }),
                        content_type == "blog_article" || content_type == "article" || content_type == "excursion" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.content.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    parentClassName: "container mb-5",
                                    skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            height: 150,
                                            className: "col-12 col-sm-12 col-md-10 b-rad-md mb-1"
                                        })
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pb-5",
                                        style: {
                                            background: backgroundColor()
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "row justify-content-center w-100 m-0",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: textColor() + " col-12 col-sm-12 col-md-10 animate-child-height ".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_general_description_centered) ? "text-md-center" : "text-md-justify"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: props.content.description
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    })
                                }),
                                _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(articleSectionContent) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: articleSectionRef,
                                        dangerouslySetInnerHTML: {
                                            __html: articleSectionContent
                                        }
                                    })
                                })
                            ]
                        }) : (content_type == "blog" || content_type == "category" || content_type == "services" || content_type == "experiences") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ArticleTypes__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                type: content_type,
                                serviceType: props.serviceType,
                                textColor: textColor(),
                                backgroundColor: backgroundColor(),
                                content: props.content,
                                app_data: app_data,
                                builder: builder,
                                viewType: viewType,
                                articlesLimit: props.articlesLimit,
                                articlesCategories: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].objChildExists */ .Z.objChildExists(props, "articlesCategories") ? props.articlesCategories : null,
                                categoryIdInhrerited: props.categoryIdInhrerited,
                                itemClassName: props.itemClassName,
                                itemWrapperClassName: props.itemWrapperClassName,
                                viewMoreBtnStyle: viewMoreBtnStyle,
                                showAllLabel: showAllLabel,
                                showFullContent: showFullContent
                            })
                        }),
                        content_type == "related_properties" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ArticleTypes__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                type: content_type,
                                serviceType: props.serviceType,
                                textColor: textColor(),
                                backgroundColor: backgroundColor(),
                                content: props.content,
                                app_data: app_data,
                                builder: builder,
                                viewType: viewType,
                                articlesLimit: props.articlesLimit,
                                articlesCategories: null,
                                articles: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].objChildExists */ .Z.objChildExists(props, "articlesCategories") ? props.articlesCategories : null,
                                categoryIdInhrerited: props.categoryIdInhrerited,
                                itemWrapperClassName: props.itemWrapperClassName,
                                viewMoreBtnStyle: viewMoreBtnStyle,
                                showFullContent: showFullContent
                            })
                        }),
                        tabsArrayComponents.length > 0 && content_type == "excursion" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: !inViewport ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pb-5",
                                    ref: tabsRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row justify-content-center w-100 m-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: textColor() + " col-12 col-sm-12 col-md-10 animate-child-height",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "row d-flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            height: 30,
                                                            width: "40%",
                                                            className: "col-4 col-sm-5 col-md-3 b-rad-md mb-1"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            height: 150,
                                                            className: "col-12 b-rad-lg"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pb-5",
                                    style: {
                                        background: backgroundColor()
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row justify-content-center w-100 m-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: textColor() + " col-12 col-sm-12 col-md-10 animate-child-height",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_properties_partials_TabsContentWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    data: tabsArrayComponents,
                                                    ReactComponentsArrayLoading: reactComponentsArrayLoading,
                                                    tabsMode: "fillUp",
                                                    tabsContentClass: "m-t-20 m-b-40",
                                                    responsiveDropdown: false
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 54106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArticleTypes; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4012);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(62286);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
// EXTERNAL MODULE: ../../shared/node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(86835);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Stack/Stack.js + 3 modules
var Stack = __webpack_require__(94368);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Pagination/Pagination.js + 8 modules
var Pagination = __webpack_require__(44023);
// EXTERNAL MODULE: ../../shared/node_modules/axios/index.js
var axios = __webpack_require__(41690);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./helpers/DataFetchHelper.ts
var DataFetchHelper = __webpack_require__(80070);
// EXTERNAL MODULE: ./components/ViewPort.tsx
var ViewPort = __webpack_require__(39806);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(417);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(41410);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92669);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(69038);
// EXTERNAL MODULE: ./components/CustomModal.tsx
var CustomModal = __webpack_require__(38977);
// EXTERNAL MODULE: ../../shared/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(31602);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(79861);
// EXTERNAL MODULE: ../../shared/node_modules/moment/moment.js
var moment = __webpack_require__(62290);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/templates/articles/ArticlesModals.tsx



// import Swiper core and required modules

// Import Swiper React components




// Import Swiper styles

// install Swiper modules
swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Lazy */.oM
]);



function ArticlesModals(props) {
    var article = props.articleModal;
    var subtitle;
    if (article !== null) {
        var created = moment_default()(new Date(article.created * 1000)).format("dddd Do MMMM");
        subtitle = props.type == "blog" ? created : props.type == "category" ? article.description : article.subtitle;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal/* default */.Z, {
        modalName: "article-" + props.modalArticleId,
        className: "slide_right",
        modalSize: "lg",
        closeModal: function() {
            props.handleHide();
        },
        show: props.modalShow,
        Title: article != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-wrap text-left mt-0",
                    children: article.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                    className: "block-title text-left mt-0",
                    children: [
                        subtitle,
                        " ",
                        Checkers/* default.isValidString */.Z.isValidString(article.tags) && " | ".concat(article.tags)
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    width: "100%",
                    height: 35
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "text",
                    width: "80%",
                    height: 20
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-body",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12",
                    children: article !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                speed: 1000,
                                navigation: true,
                                pagination: true,
                                slidesPerView: 1,
                                autoplay: false,
                                className: "mb-3",
                                style: {
                                    height: 310
                                },
                                children: Checkers/* default.isValidArray */.Z.isValidArray(article.images) && article.images.map(function(slide, index) {
                                    return Checkers/* default.isValidString */.Z.isValidString(slide.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "cursor-pointer",
                                            priority: index == 0,
                                            // loading={key == 0 ? 'eager' : 'lazy'}
                                            "data-src": slide.image,
                                            "data-fancybox": "modal-images",
                                            "data-thumb": slide.image,
                                            layout: "fill",
                                            sizes: "50vw",
                                            quality: "50",
                                            src: slide.image,
                                            alt: "Slide-" + index,
                                            objectFit: "cover",
                                            placeholder: "blur",
                                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                        })
                                    }, index.toString());
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: article.description
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                width: "100%",
                                height: 310,
                                className: "b-rad-md my-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "70%",
                                height: 18
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "100%",
                                height: 25
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "100%",
                                height: 25
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "100%",
                                height: 25
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "text",
                                width: "100%",
                                height: 25
                            })
                        ]
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/templates/articles/ArticleTypes.tsx






var CollectionsType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4729).then(__webpack_require__.bind(__webpack_require__, 44729));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44729)
            ];
        }
    },
    suspense: true
});
var MasonryType = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1100), __webpack_require__.e(3336)]).then(__webpack_require__.bind(__webpack_require__, 83336));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83336)
            ];
        }
    },
    suspense: true
});
var ColazType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7665).then(__webpack_require__.bind(__webpack_require__, 7665));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7665)
            ];
        }
    },
    suspense: true
});
var ListType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2122).then(__webpack_require__.bind(__webpack_require__, 2122));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2122)
            ];
        }
    },
    suspense: true
});
var TilesType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4931).then(__webpack_require__.bind(__webpack_require__, 4931));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4931)
            ];
        }
    },
    suspense: true
});
var ThumbsType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 336).then(__webpack_require__.bind(__webpack_require__, 80336));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80336)
            ];
        }
    },
    suspense: true
});
var ZigZagType = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8847).then(__webpack_require__.bind(__webpack_require__, 88847));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88847)
            ];
        }
    },
    suspense: true
});











function ArticleTypes(props) {
    var ref, ref1;
    var showFullContent = props.hasOwnProperty("showFullContent") ? props.showFullContent : false;
    var articlesLimitForHomepage = props.content.articlesLimitForHomepage;
    var slidesPerView = props.hasOwnProperty("slidesPerView") ? props.slidesPerView : 3;
    var showAllLabel = props.hasOwnProperty("showAllLabel") ? props.showAllLabel : "Show all";
    var articlesPerRow = function() {
        switch(viewType){
            case "400":
            case "576":
                return null;
            case "172":
            case "401":
                return 4;
            case "173":
            case "402":
                return null;
            case "204":
            case "403":
                return 1;
            case "395":
            case "404":
                return 6;
            case "397":
            case "405":
                return 4;
            case "275":
            case "406":
                return 1;
        }
    };
    var articlesLimit = function() {
        return props.categoryIdInhrerited != undefined && articlesLimitForHomepage == 1 ? articlesPerRow() * 3 : null;
    };
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var articlesContentInit = {
        type: props.articles != undefined ? "article" : "articles"
    };
    var ref2 = (0,react.useState)(articlesContentInit), articlesContent = ref2[0];
    var container_class = "container";
    if (props.type == "blog") {
        if (Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_news_view_width)) {
            container_class = props.builder.builder_news_view_width;
        }
    } else if (props.type == "category") {
        if (Checkers/* default.isValidString */.Z.isValidString(props.content.category_view_width)) {
            container_class = props.content.category_view_width;
        }
    }
    var builder = props.builder;
    var articlesCategories = props.articlesCategories;
    var viewType = props.viewType;
    var categoryIdToView = props.categoryIdInhrerited != undefined ? props.categoryIdInhrerited : router.query.category_id != undefined ? router.query.category_id.toString() : null;
    var paramsInit = {
        page_id: props.app_data.page_id,
        limit: 24,
        offset: 0,
        categories: "",
        category_id: categoryIdToView,
        categoryViewType: Checkers/* default.isValidString */.Z.isValidString(props.content.view_type) ? props.content.view_type : null,
        serviceType: null,
        isHomePage: "0",
        isExperiencesPage: "0"
    };
    // useEffect( () => {
    //   console.log("props.type", props.type)
    // })
    //
    // if (props.type === 'category' || props.type === 'experiences' )
    //   paramsInit.category_id = props.categoryIdInhrerited != undefined ? props.categoryIdInhrerited : router.query.category_id.toString();
    var params = paramsInit;
    var ref3 = (0,react.useState)(props.articles != undefined ? props.articles : []), articles = ref3[0], setArticles = ref3[1];
    var ref4 = (0,react.useState)(0), articlesCount = ref4[0], setArticlesCount = ref4[1];
    var ref5 = (0,react.useState)(false), loadingArticles = ref5[0], setLoadingArticles = ref5[1];
    var containsCategory = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.category_id) === null || ref1 === void 0 ? void 0 : ref1.length) > 1;
    var categoryFromQuery = containsCategory ? router.query.category_id : null;
    var categoryDetails = {
        categoryId: Checkers/* default.isValidString */.Z.isValidString(categoryFromQuery) && categoryFromQuery.length > 0 && parseInt(String(categoryFromQuery)) < 1 ? null : Checkers/* default.isValidString */.Z.isValidString(categoryFromQuery) && categoryFromQuery.toString().length > 0 ? categoryFromQuery : null,
        categoryUrlSlug: props.type === "category" && router.asPath.split("/").length > 1 && !router.asPath.split("/")[1].includes("category") ? router.asPath.split("/")[1] : router.asPath.split("/blog/").length > 1 && !router.asPath.split("/blog/")[1].includes("category/") ? router.asPath.split("/blog/")[1].split("/page").length > 0 ? router.asPath.split("/blog/")[1].split("/page")[0] : router.asPath.split("/blog/")[1] : null
    };
    var ref6 = (0,react.useState)(categoryDetails), categoryDetailsState = ref6[0];
    var pageFromPath = router === null || router === void 0 ? void 0 : router.asPath.split("page/")[1];
    var ref7 = (0,react.useState)(Math.ceil(articlesCount / 24)), paginationCounter = ref7[0], setPaginationCounter = ref7[1];
    var ref8 = (0,react.useState)(Checkers/* default.isValidString */.Z.isValidString(pageFromPath) && pageFromPath.toString().length > 0 && parseInt(pageFromPath) < 1 ? 1 : Checkers/* default.isValidString */.Z.isValidString(pageFromPath) && pageFromPath.toString().length > 0 ? parseInt(pageFromPath) : 1), pageNumber = ref8[0], setPageNumber = ref8[1];
    var changeCategory = (0,react.useCallback)(function(category_id, category_url_slug) {
        categoryDetailsState.categoryId = category_id;
        categoryDetailsState.categoryUrlSlug = category_url_slug;
        var asPath = "/blog";
        var pathname = "/blog";
        var queryParams = {};
        if (Checkers/* default.isValidString */.Z.isValidString(categoryDetailsState.categoryId) || Checkers/* default.isValidString */.Z.isValidString(categoryDetailsState.categoryUrlSlug)) {
            asPath = "/blog/category/".concat(categoryDetailsState.categoryId);
            pathname = "";
            if (Checkers/* default.isValidString */.Z.isValidString(categoryDetailsState.categoryUrlSlug)) {
                asPath = "/blog/".concat(categoryDetailsState.categoryUrlSlug);
            }
            queryParams = {
                category_id: categoryDetailsState.categoryId,
                page: pageNumber.toString()
            };
        }
        router.replace({
            pathname: pathname,
            query: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                queryParams: queryParams,
                page: 1
            }
        }, asPath, {
            shallow: true
        });
    }, [
        categoryDetailsState,
        pageNumber,
        router
    ]);
    var setUrlPage = (0,react.useCallback)(function() {
        var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        var asPath = "";
        var queryParams;
        asPath = router.asPath;
        if (asPath.split("/page/").length > 1) asPath = router.asPath.split("/page/")[0];
        if (Checkers/* default.isValidString */.Z.isValidString(categoryDetailsState.categoryId) || Checkers/* default.isValidString */.Z.isValidString(categoryDetailsState.categoryUrlSlug)) {
            queryParams = {
                category_id: categoryDetailsState.categoryId,
                page: page.toString()
            };
        } else {
            queryParams = {
                page: page.toString()
            };
        }
        if (page > 1) asPath += "/page/".concat(page);
        router.push({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                queryParams: queryParams
            })
        }, asPath, {
            shallow: true
        });
    }, [
        categoryDetailsState.categoryId,
        categoryDetailsState.categoryUrlSlug,
        query,
        router
    ]);
    var scrollToTop = (0,react.useCallback)(function(page) {
        setPageNumber(page);
        var barOffset = 0;
        var element = document.getElementById("articles_top");
        var scrollToYOffset = element.getBoundingClientRect().y + window.scrollY - barOffset;
        modules/* animateScroll.scrollTo */.NY.scrollTo(scrollToYOffset);
        setUrlPage(page);
    }, [
        setUrlPage
    ]);
    var pageFunction = query.page ? parseInt(query.page) : 1;
    var isHomePage = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    var isExperiencesPage = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isExperiencesPage"];
    });
    var fetchArticles = (0,react.useCallback)(function() {
        var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pageFunction;
        var ref;
        if (props.articles != undefined) {
            return;
        }
        setLoadingArticles(true);
        // setUrlPage( page );
        params.offset = (page - 1) * 24;
        if (props.articlesLimit != undefined || props.articlesLimit != null) {
            params.limit = props.articlesLimit;
            params.offset = 0;
        }
        if (props.type === "blog") params.categories = categoryDetailsState === null || categoryDetailsState === void 0 ? void 0 : (ref = categoryDetailsState.categoryId) === null || ref === void 0 ? void 0 : ref.toString();
        if (props.type === "services") {
            params.serviceType = props.serviceType;
        }
        var useCache = "";
        if (props.type === "category") {
            useCache = "1";
        }
        params.isHomePage = isHomePage;
        params.isExperiencesPage = isExperiencesPage;
        axios_default().post("/apiloggia", {
            action: "/api/lodge/frontend/get/".concat(props.type, "/articles?").concat(DataFetchHelper/* EncodeQueryData */.sX(params)),
            useCache: useCache
        }).then(function(r) {
            var responseArticles = Checkers/* default.objChildExists */.Z.objChildExists(r.data, "articles") ? r.data.articles : r.data.subcategories;
            if (props.type == "experiences") {
                articlesContent.type = "experience";
            } else {
                if (Checkers/* default.objChildExists */.Z.objChildExists(r.data, "articles")) {
                    articlesContent.type = "article";
                } else {
                    articlesContent.type = "category";
                }
            }
            setArticles(responseArticles);
            setArticlesCount(function(prev) {
                return prev = r.data.count;
            });
            if (params.offset > r.data.count) {
                fetchArticles(1);
            }
            setPaginationCounter(Math.ceil(r.data.count / 24));
            setLoadingArticles(false);
        });
    }, [
        categoryDetailsState === null || categoryDetailsState === void 0 ? void 0 : categoryDetailsState.categoryId,
        pageFunction,
        params,
        props.type
    ]);
    var filterArticlesByCategories = (0,react.useCallback)(function(event) {
        if (document !== undefined) {
            var activeListEl = document.querySelector(".filters ul>li a.active");
            if (activeListEl) activeListEl.classList.remove("active");
        }
        event.target.classList.add("active");
        setPageNumber(1);
        fetchArticles(1);
    }, [
        fetchArticles
    ]);
    var setClass = function(article, item_class) {
        switch(articlesContent.type){
            case "category":
                item_class += " cursor-pointer";
                return item_class;
            case "experience":
            case "article":
            case "blog":
                if (Checkers/* default.isValidString */.Z.isValidString(article.redirect_url)) {
                    item_class += " cursor-pointer";
                } else if (article.show_in_different_page && Checkers/* default.isValidString */.Z.isValidString(article.description)) {
                    item_class += " cursor-pointer";
                } else if (Checkers/* default.isValidString */.Z.isValidString(article.description)) {
                    item_class += " cursor-pointer";
                }
                return item_class;
        }
    };
    var ref9 = (0,react.useState)(0), modalArticleId = ref9[0], setModalArticleId = ref9[1];
    var ref10 = (0,react.useState)(null), articleModal = ref10[0], setArticleModal = ref10[1];
    var ref11 = (0,react.useState)(false), modalShow = ref11[0], setModalShow = ref11[1];
    var handleShow = function() {
        setModalShow(true);
    };
    var handleHide = function() {
        setModalShow(false);
        setArticleModal(null);
    };
    var fetchModalContent = (0,react.useCallback)(function(article) {
        var modal_params = {
            article_id: article.id,
            page_id: props.app_data.page_id,
            type: props.type
        };
        setModalArticleId(article.id);
        handleShow();
        // console.log("serviceUrl", `/api/lodge/frontend/get/article/modal/content?${DataFetchHelper.EncodeQueryData(modal_params)}`)
        axios_default().post("/apiloggia", {
            action: "/api/lodge/frontend/get/article/modal/content?".concat(DataFetchHelper/* EncodeQueryData */.sX(modal_params)),
            useCache: false
        }).then(function(response) {
            setArticleModal(response.data);
        });
    }, [
        setArticleModal,
        props.app_data.page_id
    ]);
    var clickHandler = function(article) {
        switch(articlesContent.type){
            case "article":
            case "blog":
                if (!Checkers/* default.isValidString */.Z.isValidString(article.redirect_url) && !(article.show_in_different_page && Checkers/* default.valueToBoolean */.Z.valueToBoolean(article.has_description || article.has_body)) && Checkers/* default.valueToBoolean */.Z.valueToBoolean(article.has_description)) {
                    fetchModalContent(article);
                }
                break;
        }
    };
    var updateHref = function(article) {
        var hrefUpdated = "";
        switch(articlesContent.type){
            case "experience":
                // event.currentTarget.href = `${window.origin}/`;
                if (Checkers/* default.isValidString */.Z.isValidString(article.urlSlug)) hrefUpdated = article.urlSlug;
                else if (Checkers/* default.isValidString */.Z.isValidString(article.loggiaUrl)) hrefUpdated = article.loggiaUrl;
                else hrefUpdated = "/category/".concat(article.id);
                break;
            case "category":
                // event.currentTarget.href = `${window.origin}/`;
                if (Checkers/* default.isValidString */.Z.isValidString(article.loggiaUrl)) hrefUpdated = article.loggiaUrl;
                else hrefUpdated = "/category/".concat(article.id);
                break;
            case "article":
                if (Checkers/* default.isValidString */.Z.isValidString(article.redirect_url)) {
                    hrefUpdated = article.redirect_url;
                } else if (article.show_in_different_page && Checkers/* default.valueToBoolean */.Z.valueToBoolean(article.has_description)) {
                    if (Checkers/* default.isValidString */.Z.isValidString(article.loggiaUrl)) {
                        hrefUpdated = "/".concat(article.loggiaUrl);
                    } else {
                        hrefUpdated = "/".concat(articlesContent.type, "/").concat(article.id);
                    }
                }
                break;
            case "blog":
                if (Checkers/* default.isValidString */.Z.isValidString(article.redirect_url)) {
                    hrefUpdated = article.redirect_url;
                } else if (article.show_in_different_page && Checkers/* default.valueToBoolean */.Z.valueToBoolean(article.has_description)) {
                    hrefUpdated = "".concat(articlesContent.type, "/").concat(article.id);
                } /*else if (Checkers.valueToBoolean(article.has_description)) {
          event.currentTarget.removeAttribute("href");
        }*/ 
                break;
        }
        if (hrefUpdated.startsWith("https://") || hrefUpdated.startsWith("http://")) {
        //do nothing
        } else if (hrefUpdated.length == 0) {
            hrefUpdated = "#/";
        } else if (!hrefUpdated.startsWith("/")) {
            hrefUpdated = "/" + hrefUpdated;
        }
        return hrefUpdated;
    };
    var tilesBackgroundColor = Checkers/* default.isHexColor */.Z.isHexColor(props.content.tilesBackgroundColor) ? props.content.tilesBackgroundColor : null;
    var tilesTextDarkMode = props.content.tilesTextDarkMode;
    var viewTypeSwitch = function(viewType) {
        switch(viewType){
            case "400":
            case "576":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionsType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        builder: builder,
                        content: props.content,
                        articles: articles,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        slidesPerView: slidesPerView
                    })
                });
            case "172":
            case "401":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MasonryType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        builder: builder,
                        content: props.content,
                        articles: articles,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        textColor: tilesTextDarkMode,
                        backgroundColor: tilesBackgroundColor,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        articlesLimit: articlesLimit()
                    })
                });
            case "173":
            case "402":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColazType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        builder: builder,
                        articles: articles,
                        content: props.content,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles
                    })
                });
            case "204":
            case "403":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        builder: builder,
                        content: props.content,
                        articles: articles,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        textColor: tilesTextDarkMode,
                        backgroundColor: tilesBackgroundColor,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        articlesLimit: articlesLimit()
                    })
                });
            case "395":
            case "404":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TilesType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        builder: builder,
                        content: props.content,
                        articles: articles,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        articlesLimit: articlesLimit()
                    })
                });
            case "397":
            case "405":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbsType, {
                        type: props.type,
                        articlesContentType: articlesContent.type,
                        content: props.content,
                        builder: builder,
                        articles: articles,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        // textColor={props.textColor}
                        textColor: tilesTextDarkMode,
                        backgroundColor: tilesBackgroundColor,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        articlesLimit: articlesLimit()
                    })
                });
            case "275":
            case "406":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ZigZagType, {
                        type: props.type,
                        textColor: props.textColor,
                        articlesContentType: articlesContent.type,
                        articles: articles,
                        content: props.content,
                        builder: builder,
                        clickHandler: clickHandler,
                        setClass: setClass,
                        updateHref: updateHref,
                        loadingArticles: loadingArticles,
                        itemClassName: props.itemClassName,
                        itemWrapperClassName: props.itemWrapperClassName,
                        articlesLimit: articlesLimit(),
                        showFullContent: showFullContent
                    })
                });
        }
    };
    (0,react.useEffect)(function() {
    // console.log("debugTypes", viewType, props.type, articles)
    });
    (0,react.useEffect)(function() {
        fetchArticles(pageNumber);
    }, [
        categoryIdToView
    ]);
    (0,react.useEffect)(function() {
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        articleModal
    ]);
    var ref12 = (0,_sliced_to_array/* default */.Z)(useHookWithRefCallback(categoryDetailsState.categoryId), 1), ref13 = ref12[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.isValidArray */.Z.isValidArray(articlesCategories) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-master-lightest pb-4",
                style: {
                    background: props.backgroundColor != undefined && Checkers/* default.isHexColor */.Z.isHexColor(props.backgroundColor) ? props.backgroundColor : ""
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center border-top filters",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-sm-auto text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "no-style m-0 py-1 py-sm-3 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPort/* default */.Z, {
                                        parentClassName: "inline px-2",
                                        skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-auto p-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    height: 15,
                                                    width: 80,
                                                    className: "col-12"
                                                })
                                            })
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            ref: ref13,
                                            id: "all-categories",
                                            className: "col-auto inline text-center py-2 py-sm-0 m-0 px-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "link text-black fs-13 block-title cursor-pointer " + props.textColor,
                                                onClick: function(event) {
                                                    changeCategory(null, null);
                                                    filterArticlesByCategories(event);
                                                },
                                                children: "All"
                                            })
                                        })
                                    }),
                                    articlesCategories.map(function(category, index) {
                                        var width = 95;
                                        if (index % 2 == 0) {
                                            width = 65;
                                        } else if (index % 3 == 0) {
                                            width = 80;
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPort/* default */.Z, {
                                            parentClassName: "inline px-2 mb-2",
                                            skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-auto p-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    height: 15,
                                                    width: width,
                                                    className: "col-12"
                                                })
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                ref: ref13,
                                                id: "category-".concat(category.id),
                                                className: "col-auto inline text-center py-2 py-sm-0 m-0 px-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "link text-black fs-13 block-title cursor-pointer " + props.textColor,
                                                    onClick: function(event) {
                                                        changeCategory(category.id.toString(), category.urlSlug);
                                                        filterArticlesByCategories(event);
                                                    },
                                                    children: category.title
                                                })
                                            }, category.id.toString())
                                        }, category.id.toString());
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    viewTypeSwitch(viewType),
                    articlesLimit() != null && Checkers/* default.isValidPositiveNumber */.Z.isValidPositiveNumber(articlesLimit()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container text-center p-b-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-auto text-center",
                                    children: props.viewMoreBtnStyle == "primary" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/" + props.content.urlSlug,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-primary btn-design-color p-4 p-t-10 p-b-10",
                                            children: showAllLabel
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/" + props.content.urlSlug,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-rounded btn-black btn-bordered",
                                            children: showAllLabel
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    // props.content.urlSlug, props.type
                    (isExperiencesPage || isHomePage) && props.type == "experiences" && articlesCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container text-center p-b-40",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-auto text-center",
                                    children: props.viewMoreBtnStyle == "primary" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/" + (Checkers/* default.isValidString */.Z.isValidString(props.content.urlSlug) ? props.content.urlSlug : "excursions/" + props.content.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-primary btn-design-color p-4 p-t-10 p-b-10",
                                            children: showAllLabel
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/" + (Checkers/* default.isValidString */.Z.isValidString(props.content.urlSlug) ? props.content.urlSlug : "excursions/" + props.content.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn btn-rounded btn-black btn-bordered",
                                            children: showAllLabel
                                        })
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            props.articlesLimit == undefined && articlesCount > 24 && paginationCounter > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: container_class,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row w-100 m-0 py-5 justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                spacing: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    page: pageNumber,
                                    classes: {
                                        ul: props.textColor
                                    },
                                    count: paginationCounter,
                                    onChange: function(event, page) {
                                        scrollToTop(page);
                                        fetchArticles(page);
                                    },
                                    getItemAriaLabel: function(button, number) {
                                        switch(button){
                                            case "page":
                                                return "".concat(number);
                                            case "previous":
                                                return "previous";
                                            case "next":
                                                return "next";
                                        }
                                    }
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesModals, {
                type: articlesContent.type,
                modalShow: modalShow,
                articleModal: articleModal,
                modalArticleId: modalArticleId,
                handleHide: handleHide
            })
        ]
    });
}
function useHookWithRefCallback() {
    var categoryId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref = (0,react.useRef)(null);
    var setRef = (0,react.useCallback)(function(node) {
        if (ref.current) {
            if (categoryId == null && ref.current.id == "all-categories") {
                ref.current.children[0].classList.add("active");
            } else if (categoryId > 0) {
                if (String(ref.current.id.split("-")[1]) == String(categoryId)) {
                    ref.current.children[0].classList.add("active");
                }
            }
        }
        // Save a reference to the node
        ref.current = node;
    }, []);
    return [
        setRef
    ];
}


/***/ }),

/***/ 3055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83974);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89736);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91932);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23158);





var TabsContentWrapper = function(param) {
    var data = param.data, ReactComponentsArrayLoading = param.ReactComponentsArrayLoading, tabsContentClass = param.tabsContentClass, backgroundColor = param.backgroundColor, darkMode = param.darkMode, _tabsMode = param.tabsMode, tabsMode = _tabsMode === void 0 ? "lineTriangle" : _tabsMode, _responsiveDropdown = param.responsiveDropdown, responsiveDropdown = _responsiveDropdown === void 0 ? true : _responsiveDropdown;
    // <div className="card card-transparent  m-b-0">
    //     {/*<div className={"nav-tabs-header " + (isDarkMode(darkMode) ? "nav-tabs-dark-mode" : "") }>*/}
    //     <ul className="nav nav-tabs nav-tabs-fillup hidden-sm hidden-xs"
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !ReactComponentsArrayLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    background: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isHexColor */ .Z.isHexColor(backgroundColor) ? backgroundColor : ""
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container p-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row w-100 no-margin",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-md-12 no-padding",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "panel panel-transparent m-b-0",
                                children: [
                                    tabsMode == "fillUp" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "nav-tabs-header " + ((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .isDarkMode */ .Yc)(darkMode) ? "nav-tabs-dark-mode" : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "nav nav-tabs nav-tabs-fillup " + (responsiveDropdown ? "hidden-sm hidden-xs" : ""),
                                                role: responsiveDropdown ? "tablist" : "",
                                                "data-init-reponsive-tabs": responsiveDropdown ? "dropdownfx" : "",
                                                children: data.map(function(tab, i) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .textColor */ .zP)(darkMode) + " fs-12 " + (i == 0 ? "active" : ""),
                                                                "data-toggle": "tab",
                                                                href: "#slide" + tab.tabId,
                                                                "data-bs-toggle": "tab",
                                                                "data-bs-target": "#slide" + tab.tabId,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: tab.tabTitle
                                                                })
                                                            })
                                                        })
                                                    });
                                                })
                                            })
                                        })
                                    }),
                                    tabsMode == "lineTriangle" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "nav-tabs-header nav-tabs-linetriangle " + ((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .isDarkMode */ .Yc)(darkMode) ? "nav-tabs-dark-mode" : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "nav nav-tabs w-100 nav-tabs-linetriangle " + (responsiveDropdown ? "hidden-sm hidden-xs" : ""),
                                                style: {
                                                    width: "auto",
                                                    whiteSpace: "nowrap",
                                                    display: "inline-block"
                                                },
                                                role: responsiveDropdown ? "tablist" : "",
                                                "data-init-reponsive-tabs": responsiveDropdown ? "dropdownfx" : "",
                                                children: data.map(function(tab, i) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_3__/* .textColor */ .zP)(darkMode) + " fs-12 " + (i == 0 ? "active" : ""),
                                                                "data-toggle": "tab",
                                                                href: "#slide" + tab.tabId,
                                                                "data-bs-toggle": "tab",
                                                                "data-bs-target": "#slide" + tab.tabId,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: tab.tabTitle
                                                                })
                                                            })
                                                        })
                                                    });
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "tab-content " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(tabsContentClass) ? tabsContentClass : ""),
                                        style: {
                                            background: "transparent"
                                        },
                                        children: data.map(function(tab, i) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tab-pane fade " + (i == 0 ? "show active" : ""),
                                                    id: "slide" + tab.tabId,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: tab.tabContent
                                                    })
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row w-100 no-margin",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-md-12 no-padding",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "panel panel-transparent m-b-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                height: 30,
                                className: "col-8 col-sm-5 col-md-3 b-rad-md mb-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                height: 42,
                                className: "col-9 col-sm-7 col-md-5 b-rad-md mb-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                height: 180,
                                className: "col-12 b-rad-lg"
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TabsContentWrapper);


/***/ })

}]);